import { render, staticRenderFns } from "./DescriptionComboboxSearch.vue?vue&type=template&id=3e5c3af1&scoped=true"
import script from "./DescriptionComboboxSearch.vue?vue&type=script&lang=js"
export * from "./DescriptionComboboxSearch.vue?vue&type=script&lang=js"
import style0 from "./DescriptionComboboxSearch.vue?vue&type=style&index=0&id=3e5c3af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c3af1",
  null
  
)

export default component.exports